<div class="admin-general-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title class="dialog-title">
      <ng-container [ngSwitch]="step">
        <span *ngSwitchCase="'confirm'">Switch these employees to Employee Controlled?</span>
        <span *ngSwitchCase="'processing'">Updating tracking settings…</span>
        <span *ngSwitchDefault>Settings updated</span>
      </ng-container>
    </h2>
    <button mat-icon-button type="button" (click)="onCancel()" aria-label="Close dialog"
      [disabled]="step === 'processing'">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <ng-container *ngIf="step === 'confirm'">
      <div class="notice notice-info">
        <mat-icon>info</mat-icon>
        <p>
          We'll switch affected employees to Employee Controlled tracking. App, login, and history stay the same.
        </p>
      </div>

      <div class="grid grid-cols-2 gap-2 mb-4 text-[13px]">
        <div class="rounded-lg border border-slate-200 bg-slate-50 px-3 py-2">
          <p class="!m-0 text-[11px] font-semibold uppercase tracking-wide text-slate-500">Now</p>
          <p class="!mb-0 !mt-1 text-slate-700">Admin Controlled. Tracking stays on.</p>
        </div>
        <div class="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2">
          <p class="!m-0 text-[11px] font-semibold uppercase tracking-wide text-amber-800">After</p>
          <p class="!mb-0 !mt-1 text-amber-900">They can start and stop their own tracking.</p>
        </div>
      </div>

      <div class="affected-employees" *ngIf="data.employees.length">
        <p class="affected-employees-label">Affected employees ({{ employeeCount }})</p>
        <div class="employee-chips">
          <span class="employee-chip" *ngFor="let emp of data.employees" [matTooltip]="getEmployeeTooltip(emp)"
            matTooltipPosition="above">
            <span class="employee-chip-avatar" aria-hidden="true">{{ getEmployeeInitials(emp.name) }}</span>
            <span class="employee-chip-label">{{ emp.name }}</span>
          </span>
        </div>
      </div>

      <ol class="steps-list">
        <li>Turn off Auto Tracking for {{ employeeCount }} employee{{ employeeCount === 1 ? '' : 's' }}.</li>
        <li>Turn off Strict Time Tracking where enabled.</li>
        <li>Same login and history.</li>
        <li>They can start/stop tracking on next use.</li>
      </ol>

      <p class="helper-text">
        You can also change these toggles under Settings → Tracking Controls.
      </p>

      <p class="error-text" *ngIf="errorMessage">{{ errorMessage }}</p>
    </ng-container>

    <ng-container *ngIf="step === 'processing'">
      <div class="processing-state">
        <mat-spinner diameter="42"></mat-spinner>
        <p>Disabling Admin Controlled toggles for {{ employeeCount }} employee{{ employeeCount === 1 ? '' : 's' }}…</p>
      </div>
    </ng-container>

    <ng-container *ngIf="step === 'result'">
      <div class="notice notice-success" *ngIf="successfulResults.length">
        <mat-icon>check_circle</mat-icon>
        <p>
          {{ successfulResults.length }} employee{{ successfulResults.length === 1 ? '' : 's' }} switched to
          Employee Controlled. Passwords were not changed. No reinstall needed.
        </p>
      </div>

      <div class="notice notice-warning" *ngIf="failedResults.length">
        <mat-icon>warning</mat-icon>
        <p>
          {{ failedResults.length }} employee{{ failedResults.length === 1 ? '' : 's' }} could not be updated. Turn off the toggles in Employee Settings.
        </p>
      </div>

      <!-- <ul class="result-list" *ngIf="successfulResults.length">
        <li *ngFor="let result of successfulResults">{{ result.name }}</li>
      </ul>
 -->
      <p class="helper-text" *ngIf="successfulResults.length">
        Ask employees to reopen SuperSee if it was running.
      </p>
    </ng-container>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <ng-container [ngSwitch]="step">
      <ng-container *ngSwitchCase="'confirm'">
        <button mat-stroked-button type="button" (click)="onCancel()">Cancel</button>
        <button mat-raised-button color="primary" type="button" (click)="onConfirm()">
          Switch to Employee Controlled
        </button>
      </ng-container>
      <ng-container *ngSwitchCase="'result'">
        <button mat-raised-button color="primary" type="button" (click)="onDone()">Done</button>
      </ng-container>
    </ng-container>
  </mat-dialog-actions>
</div>